/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddAdhocContactResponse
 */
export interface AddAdhocContactResponse {
    /**
     * 
     * @type {string}
     * @memberof AddAdhocContactResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AddAdhocContactResponse
     */
    message: string;
}

/**
 * Check if a given object implements the AddAdhocContactResponse interface.
 */
export function instanceOfAddAdhocContactResponse(value: object): value is AddAdhocContactResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AddAdhocContactResponseFromJSON(json: any): AddAdhocContactResponse {
    return AddAdhocContactResponseFromJSONTyped(json, false);
}

export function AddAdhocContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddAdhocContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'message': json['message'],
    };
}

export function AddAdhocContactResponseToJSON(value?: AddAdhocContactResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'message': value['message'],
    };
}

